import { useEffect, useRef } from 'react';

import { iaRa } from 'lib/helpers/utility';
import { useTableContext } from 'lib/context/TableContext/TableContext';

import { showHighlighted } from './highlightFilter';
import { matchesHighlight } from './useRowHighlight';

const landingOf = (highlight) =>
  highlight?.open ? `${highlight.key}:${highlight.id}:${highlight.nonce ?? ''}` : null;

const useOpenHighlighted = ({ highlight, items, isMissing, isLoading, canOpen, open }) => {
  const table = useTableContext();
  const openedRef = useRef(null);
  const revealedRef = useRef(null);
  const landing = landingOf(highlight);

  useEffect(() => {
    if (!landing || !canOpen || isLoading || openedRef.current === landing) return;
    const row = iaRa(items).find((data) => matchesHighlight(data, highlight));
    if (row) {
      openedRef.current = landing;
      open(row);
      return;
    }
    if (!isMissing || revealedRef.current === landing) return;
    revealedRef.current = landing;
    showHighlighted(highlight, table);
  }, [landing, highlight, items, isMissing, isLoading, canOpen, open, table]);
};

export default useOpenHighlighted;
